import styled from "styled-components";
import { colors } from "@/theme";

export const CartTable = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 0;
`;


export const ProductCartHeaderContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  padding: 24px 0 12px 0;
  border-bottom: 1px solid ${colors.silverSand};
`;

export const ProductCartHeaderLabel = styled.div`
  color: ${colors.black};
  font-family: "PF DIN Text Pro";
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  justify-self: start;
`;